import { render, staticRenderFns } from "./ex-to-top.vue?vue&type=template&id=6470a734&scoped=true&"
import script from "./ex-to-top.vue?vue&type=script&lang=js&"
export * from "./ex-to-top.vue?vue&type=script&lang=js&"
import style0 from "./ex-to-top.vue?vue&type=style&index=0&id=6470a734&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6470a734",
  null
  
)

export default component.exports